const $inject = ['$q', '$http', 'apiService'];

const departmentService = function ($q, $http, apiService) {
  let service = {
    getAllDepartments,
    getDepartments,
    getCostCentres,
  };

  function getAllDepartments() {
    let deferred = $q.defer();
    let apiUrl = apiService.getUrl('department');

    $http
      .get(apiUrl)
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch(() => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function getDepartments(params) {
    let deferred = $q.defer();
    let apiUrl = apiService.getUrl('department');

    $http
      .get(apiUrl, { params: params })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch(() => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  function getCostCentres(params) {
    let deferred = $q.defer();
    let apiUrl = apiService.getUrl('costCentres');

    $http
      .get(apiUrl, { params: params })
      .then((response) => {
        deferred.resolve(response.data);
      })
      .catch(() => {
        deferred.reject('there was an error');
      });

    return deferred.promise;
  }

  return service;
};

departmentService.$inject = $inject;

export default departmentService;



// WEBPACK FOOTER //
// ./src/services/departmentService.js